import { Box, Button, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { DialogBox } from '~pages/pages-behind-login/chartering/pre-fixture-page/components/dialog-box'
import { ExactScopeName, useHasScope } from '~hooks/permissions/use-has-scope'
import { useGetMe } from '~hooks/queries/me/use-get-me'
import { usePatchUsersVt } from '~hooks/queries/users/use-patch-users-vt'
import { content } from '~pages/open-pages/terms-and-conditions/content'

export function TermsOfUseModal() {
  const isMtUser = useHasScope(ExactScopeName.maerskTankersUser)

  // isMtUser is undefined while loading, true if the user has the scope, false if the user does not have the scope
  if (isMtUser === undefined || isMtUser) return null

  return <TermsOfUseModalRenderer />
}

function TermsOfUseModalRenderer() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { data } = useGetMe()
  const { mutate: patchUser } = usePatchUsersVt(data?.sub || undefined)

  useEffect(() => {
    if (data && !data?.ToSAcceptedDate) {
      setIsModalOpen(true)
      return
    }

    setIsModalOpen(false)
  }, [data])

  function onClickHandler() {
    patchUser({
      ToSAcceptedDate: new Date().toISOString(),
    })
    setIsModalOpen(false)
  }

  const { title, article } = content
  return (
    <DialogBox open={isModalOpen} onClose={() => setIsModalOpen(false)}>
      <Typography variant="h2" sx={{ mb: 3 }}>
        {title}
      </Typography>
      <Typography component="article" sx={{ mb: 5 }}>
        {article}
      </Typography>
      <Button onClick={onClickHandler}>Accept</Button>
    </DialogBox>
  )
}
